import { FC, useState, useEffect } from 'react'
import { Box, Typography, Card, CardContent } from '@mui/material'
import { useParams, useNavigate } from 'react-router-dom'
import ClientSearch from './ClientSearch'
import ClientUpdateForm from './ClientUpdateForm'
import { Person } from '@services/contacts/contacts.models'
import { usePersonDetails } from '@services/contacts/contacts.hooks'

const ClientManagement: FC = () => {
  const [selectedPersonId, setSelectedPersonId] = useState<number | null>(null)
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const { data: selectedPerson } = usePersonDetails(selectedPersonId)

  useEffect(() => {
    if (id) {
      setSelectedPersonId(parseInt(id, 10))
    } else {
      setSelectedPersonId(null)
    }
  }, [id])

  const handleSelectPerson = (person: Person) => {
    navigate(`/clients/${person.id}/edit`)
  }

  const handleCancelEdit = () => {
    navigate('/clients')
  }

  const handleSavePerson = () => {
    navigate('/clients')
  }

  if (selectedPerson) {
    return (
      <ClientUpdateForm
        person={selectedPerson}
        onCancel={handleCancelEdit}
        onSave={handleSavePerson}
      />
    )
  }

  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <Typography variant='h4' gutterBottom sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }}>
        Zarządzanie danymi klientów
      </Typography>

      <Card>
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Typography variant='h6' gutterBottom>
            Wyszukaj klienta
          </Typography>
          <Typography variant='body2' color='text.secondary' sx={{ mb: 3 }}>
            Użyj pola wyszukiwania aby odnaleźć klienta po imieniu, nazwisku, emailu lub numerze
            telefonu
          </Typography>

          <ClientSearch onSelectPerson={handleSelectPerson} />
        </CardContent>
      </Card>
    </Box>
  )
}

export default ClientManagement
